import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  E_ChannelOptions,
  T_CsAppSliceState,
  T_NavtiveDeviceInfo,
  T_UserAgent,
} from "../../globalTypes/GlobalTypes";
// import { loginRtk } from "../../features/Feature_Login/Login_Api";
import _ from "lodash";
import { loginRtk } from "../../features/Feature_Login/Login_Api";
import { getCookie, NATIVE_DEVICE_INFO } from "../../utils/CSCookieHandler";

const initialState: T_CsAppSliceState = {
  tokenDetails: undefined,
  userDetails: undefined,
  userAgent: undefined,
  traceId: undefined,
  deviceType: undefined,
  NativeDeviceInfo:
    (JSON.parse(`${getCookie(NATIVE_DEVICE_INFO)}`) as T_NavtiveDeviceInfo) ||
    undefined,
  channel: "CSAPP" as E_ChannelOptions.CSAPP,
  platform: "web",
  csUserId: "",
  ipAddress: "",
  emailId: "",
  tempLeadName: "",
  ciiNoFromTerraData: "",
};

export const CsAppSlice = createSlice({
  name: "CsAppSlice",
  initialState: initialState,
  reducers: {
    updateChannelDetails: (state, action: PayloadAction<E_ChannelOptions>) => {
      return {
        ...state,
        channel: action.payload,
      };
    },
    updateTraceId: (state, action) => {
      return {
        ...state,
        traceId: action.payload,
      };
    },
    setDeviceType: (state, action) => {
      return {
        ...state,
        deviceType: action.payload,
      };
    },
    setNativeDeviceInfo: (
      state,
      action: PayloadAction<T_NavtiveDeviceInfo>,
    ) => {
      return {
        ...state,
        platform: action.payload?.systemName === "Android" ? "android" : "ios",
        NativeDeviceInfo: action.payload,
      };
    },
    setTokenDetails: (state, action) => {
      return {
        ...state,
        tokenDetails: action.payload,
      };
    },
    setLongSessionAuthToken: (state: any, action: PayloadAction<string>) => {
      return {
        ...state,
        tokenDetails: {
          ...state.tokenDetails,
          internal: {
            ...state.tokenDetails?.internal,
            authToken: action.payload,
            longSessionAuthToken: action.payload,
          },
        },
      };
    },
    setCustomerAndLobDetails: (state, action) => {
      return {
        ...state,
        userDetails: { ...state.userDetails, ...action.payload },
      };
    },
    clearCustomerAndLobDetailsArr: (state) => {
      return {
        ...state,
        userDetails: undefined,
      };
    },
    updateUserProfileDetails: (state, action) => {
      return {
        ...state,
        userDetails: { ...state.userDetails, ...action.payload },
      };
    },
    updateUserProfilePanDetails: (state, action) => {
      return {
        ...state,
        userDetails: { ...state.userDetails, ...action.payload },
      };
    },
    saveCsUserId: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        csUserId: action.payload,
      };
    },
    saveEmailId: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        emailId: action.payload,
      };
    },
    saveTempLeadName: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        tempLeadName: action.payload,
      };
    },
    setUserAgentDetails: (state, action: PayloadAction<T_UserAgent>) => {
      return {
        ...state,
        userAgent: action.payload,
      };
    },
    setIpAddress: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        ipAddress: action.payload,
      };
    },
    saveCiiNoFromTerraData: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        ciiNoFromTerraData: action.payload,
      };
    },
    resetCsAppSliceToInitialState: () => {
      return initialState;
    },
  },
  // extraReducers(builder) {
  //   builder.addMatcher(
  //     loginRtk.endpoints.getCustomerLobDetails.matchFulfilled,
  //     (state, action) => {
  //       let tempData = action?.payload?.payload.customerAndLobDetails
  //         ? {
  //             ...state.userDetails,
  //             CS_USER_ID: _.isEmpty(state.userDetails?.CS_USER_ID)
  //               ? action?.payload?.payload.CS_USER_ID
  //               : "" + state?.userDetails?.CS_USER_ID,
  //             IS_FIRST_TIME_USER:
  //               !!action?.payload?.payload?.IS_FIRST_TIME_USER,
  //             IS_USER_REGISTERED:
  //               !!action?.payload?.payload?.IS_USER_REGISTERED,
  //             customerAndLobDetails: [
  //               ...action?.payload?.payload?.customerAndLobDetails,
  //             ],
  //           }
  //         : undefined;
  //       return {
  //         ...state,
  //         userDetails: tempData,
  //       };
  //     }
  //   );
  // },
});

export const CsAppSliceReducer = CsAppSlice.reducer;
export const CsAppSliceKey = CsAppSlice.reducerPath;

export const {
  setUserAgentDetails,
  setDeviceType,
  setNativeDeviceInfo,
  setTokenDetails,
  setCustomerAndLobDetails,
  updateTraceId,
  updateUserProfileDetails,
  setLongSessionAuthToken,
  updateChannelDetails,
  clearCustomerAndLobDetailsArr,
  saveCsUserId,
  updateUserProfilePanDetails,
  setIpAddress,
  resetCsAppSliceToInitialState,
  saveEmailId,
  saveTempLeadName,
  saveCiiNoFromTerraData,
} = CsAppSlice.actions;
